import { useCallback } from 'react';
import {usePost, UsePostParams} from "../../../../api";
import {IncidentsConfiguration, SaveIncidentConfigPayload} from "../../IncidentsConfiguration/types";

const ENDPOINT = '/incidents/saveConfigurations';

export type UseSaveIncidentConfigurationParams = UsePostParams<SaveIncidentConfigPayload, {}>;

const useSaveExposuresConfiguration = (usePostParams: UseSaveIncidentConfigurationParams) => {
    const { post, ...rest } = usePost<SaveIncidentConfigPayload, IncidentsConfiguration>(usePostParams);

    const saveIncidentConfigurations = useCallback(
        (params: SaveIncidentConfigPayload) => post(ENDPOINT, params),
        [post]
    );

    return {
        ...rest,
        saveIncidentConfigurations
    };
};

export default useSaveExposuresConfiguration;